(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-faq';

  /* ---- Accordion open/close ------------------------------------------------ */
  function toggleItem(trigger) {
    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    var answerId = trigger.getAttribute('aria-controls');
    var answer = answerId ? document.getElementById(answerId) : null;
    if (!answer) {
      answer = trigger.parentElement
        ? trigger.parentElement.querySelector('[data-faq-answer]')
        : null;
    }
    if (!answer) return;

    if (expanded) {
      trigger.setAttribute('aria-expanded', 'false');
      answer.setAttribute('aria-hidden', 'true');
      answer.setAttribute('hidden', '');
    } else {
      trigger.setAttribute('aria-expanded', 'true');
      answer.setAttribute('aria-hidden', 'false');
      answer.removeAttribute('hidden');
    }
  }

  /* ---- Tabs ---------------------------------------------------------------- */
  function activateTab(section, targetTab) {
    var targetId = targetTab.getAttribute('aria-controls');
    var tabs = section.querySelectorAll('[data-faq-tab]');
    for (var i = 0; i < tabs.length; i++) {
      var tab = tabs[i];
      var isActive = tab === targetTab;
      tab.classList.toggle('oddit-section-faq__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    }

    var panels = section.querySelectorAll('[data-faq-panel]');
    for (var j = 0; j < panels.length; j++) {
      var panel = panels[j];
      var isMatch = panel.id === targetId;
      panel.classList.toggle('oddit-section-faq__panel--active', isMatch);
      if (isMatch) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    }
  }

  /* ---- Show more / less ---------------------------------------------------- */
  function toggleShowMore(button) {
    var panel = button.closest('[data-faq-panel]') || button.parentElement;
    if (!panel) return;
    var items = panel.querySelectorAll('[data-faq-collapsible]');
    var textEl = button.querySelector('[data-faq-show-more-text]');
    var moreCount = button.getAttribute('data-faq-more-count') || '';
    var expanded = button.getAttribute('aria-expanded') === 'true';

    for (var i = 0; i < items.length; i++) {
      if (expanded) {
        items[i].setAttribute('hidden', '');
      } else {
        items[i].removeAttribute('hidden');
      }
    }

    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    if (textEl) {
      textEl.textContent = expanded ? 'Show ' + moreCount + ' More' : 'Show less';
    }
  }

  /* ---- Event delegation ---------------------------------------------------- */
  function handleClick(event) {
    var section = event.currentTarget;

    var showMore = event.target.closest('[data-faq-show-more]');
    if (showMore) {
      event.preventDefault();
      toggleShowMore(showMore);
      return;
    }

    var tab = event.target.closest('[data-faq-tab]');
    if (tab) {
      event.preventDefault();
      activateTab(section, tab);
      return;
    }

    var trigger = event.target.closest('[data-faq-trigger]');
    if (trigger) {
      event.preventDefault();
      toggleItem(trigger);
    }
  }

  function handleKeydown(event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    var tab = event.target.closest('[data-faq-tab]');
    if (!tab) return;
    event.preventDefault();

    var section = event.currentTarget;
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-faq-tab]'));
    var idx = tabs.indexOf(tab);
    if (idx === -1) return;

    var nextIdx = event.key === 'ArrowRight'
      ? (idx + 1) % tabs.length
      : (idx - 1 + tabs.length) % tabs.length;
    tabs[nextIdx].focus();
    activateTab(section, tabs[nextIdx]);
  }

  function initSection(section) {
    if (!section || section.dataset.odditFaqInit === 'true') return;
    section.dataset.odditFaqInit = 'true';
    section.addEventListener('click', handleClick);
    section.addEventListener('keydown', handleKeydown);
  }

  function init() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector
      ? event.target.querySelector(SECTION_SELECTOR)
      : null;
    if (section) initSection(section);
  });
})();
